import { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";

const useDashboardStats = () => {
  const [usersCount, setUsersCount] = useState(0);
  const [categoriesCount, setCategoriesCount] = useState(0);
  const [expenseSharingGroupCount, setExpenseSharingGroupCount] = useState(0);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      const [usersResponse, categoriesResponse, sharingResponse] = await Promise.all([
        apiClient.get("users/count"),
        apiClient.get("category/count"),
        apiClient.get("sharing/admin/stats").catch(() => ({
          data: { success: true, data: { groupCount: 0 } },
        })),
      ]);

      setUsersCount(usersResponse.data.data);
      setCategoriesCount(categoriesResponse.data.data);
      const g = sharingResponse?.data?.data?.groupCount;
      setExpenseSharingGroupCount(typeof g === "number" ? g : 0);
    } catch (error) {
      console.error("Error fetching statistics:", error);
    }
  };

  return { usersCount, categoriesCount, expenseSharingGroupCount };
};

export default useDashboardStats;
